"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactI18next = require("react-i18next");

var _styles = require("@mui/material/styles");

var _BrandInput = _interopRequireDefault(require("../../BrandInput"));

var _context = require("../context");

var _BrandFileInput = _interopRequireDefault(require("../../BrandFileInput"));

var _common = require("../../../common");

var _FormSection = _interopRequireDefault(require("../components/FormSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StyledBox = (0, _styles.styled)(_material.Box)(function (_ref) {
  var theme = _ref.theme;
  return "\n    & {\n      .required {\n        &::after {\n          content: \"*\";\n          color: ".concat(theme.palette.error.main, ";\n          margin-left: 0.25rem;\n        }\n      }\n    }\n  ");
});

function Other() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_context.FormContext),
      report = _useContext.report,
      setReport = _useContext.setReport;

  var _useContext2 = (0, _react.useContext)(_context.FormContext),
      isLoading = _useContext2.isLoading;

  var validateForm = function validateForm(form) {
    if (!form) return {
      isValid: false
    };
    var isValid = !!((0, _common.validateEmail)(form.email) && form.body);
    return _objectSpread(_objectSpread({}, form), {}, {
      isValid: isValid
    });
  };

  var applyFormChanges = function applyFormChanges(form) {
    return setReport(validateForm(form));
  };

  (0, _react.useEffect)(function () {
    return function () {
      return applyFormChanges({});
    };
  }, []);

  var handleChange = function handleChange(_ref2) {
    var field = _ref2.field,
        value = _ref2.value;
    applyFormChanges(_objectSpread(_objectSpread({}, report), {}, _defineProperty({}, field, value)));
  };

  return /*#__PURE__*/_react.default.createElement(StyledBox, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h5",
    component: "h2",
    sx: {
      mb: 1
    }
  }, t('feedback_report_form_other_title')), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2",
    component: "p",
    sx: {
      color: 'error.main'
    }
  }, t('feedback_report_form_required_field')), /*#__PURE__*/_react.default.createElement(_FormSection.default, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    component: "p",
    className: "required"
  }, t('feedback_report_form_follow_up_email')), /*#__PURE__*/_react.default.createElement(_BrandInput.default, {
    shouldValidateEmail: true,
    disabled: isLoading,
    value: report.email,
    placeholder: t('feedback_report_form_field_placeholder_email'),
    onChange: function onChange(e) {
      return handleChange({
        field: 'email',
        value: e.target.value
      });
    }
  })), /*#__PURE__*/_react.default.createElement(_FormSection.default, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    component: "p",
    className: "required"
  }, t('feedback_report_form_other_encounters')), /*#__PURE__*/_react.default.createElement(_BrandInput.default, {
    multiline: true,
    disabled: isLoading,
    rows: 5,
    value: report.body,
    placeholder: t('feedback_report_form_field_placeholder_description'),
    onChange: function onChange(e) {
      return handleChange({
        field: 'body',
        value: e.target.value
      });
    }
  })), /*#__PURE__*/_react.default.createElement(_FormSection.default, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    component: "p"
  }, t('feedback_report_form_bug_image')), /*#__PURE__*/_react.default.createElement(_BrandFileInput.default, {
    disabled: isLoading,
    type: "image",
    files: report.image,
    onChange: function onChange(files) {
      return handleChange({
        field: 'image',
        value: files
      });
    }
  })));
}

var _default = Other;
exports.default = _default;